import { type SelectionInputFeature } from '../../features/types.ts';
import { isTimelineSelectionFeatureEnabled } from '../utils/is-timeline-selection-feature-enabled.ts';

import { createViewChangesInputFeature } from './create-view-changes-input-feature.ts';

export function createTimelineViewChangesInputFeature(): SelectionInputFeature {
  return {
    ...createViewChangesInputFeature(),
    isEnabled: isTimelineSelectionFeatureEnabled,
  };
}
